module.exports = __webpack_public_path__ + "img/mat_212.fe8edcd9.png";